/**
 * Created by jerry on 2017/11/13.
 * 用户相关api
 */
import * as API from './'

export default {
  //登录
  login: params => {
    return API.POST('/api/app/login.php', params) 
  },
  dxjl: params => {
      return API.POST('/api/app/common.php', params) 
  },
  //微信支付
  wxpay: params => {
    return API.POST('/api/wxpay/example/wxpay.php', params) 
  },
  // 查询支付
  cxpay: params => {
    return API.POST('/api/wxpay/example/orderqueryajax.php', params) 
  },
  //发送验证码
  sendsms: params => {
    return API.POST('/api/app/sms.php', params) 
  },
  //登出
  logout: params => {
    return API.GET('/api/v1/users/logout', params)
  },
  //修改个人信息
  changeProfile: params => {
    return API.PATCH('/api/v1/users/profile', params)
  },

  //查询获取user列表(通过page分页)
  findList: params => {
    return API.GET('/api/v1/users', params)
  },
  // 解码
  base64decode: str =>{
    var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var base64DecodeChars = new Array(-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1);
      var c1, c2, c3, c4;
      var i, len, out;
      len = str.length;
      i = 0;
      out = "";
      while (i < len) {
          /* c1 */
          do {
              c1 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
          }
          while (i < len && c1 == -1);
          if (c1 == -1) 
              break;
          /* c2 */
          do {
              c2 = base64DecodeChars[str.charCodeAt(i++) & 0xff];
          }
          while (i < len && c2 == -1);
          if (c2 == -1) 
              break;
          out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4));
          /* c3 */
          do {
              c3 = str.charCodeAt(i++) & 0xff;
              if (c3 == 61) 
                  return out;
              c3 = base64DecodeChars[c3];
          }
          while (i < len && c3 == -1);
          if (c3 == -1) 
              break;
          out += String.fromCharCode(((c2 & 0XF) << 4) | ((c3 & 0x3C) >> 2));
          /* c4 */
          do {
              c4 = str.charCodeAt(i++) & 0xff;
              if (c4 == 61) 
                  return out;
              c4 = base64DecodeChars[c4];
          }
          while (i < len && c4 == -1);
          if (c4 == -1) 
              break;
          out += String.fromCharCode(((c3 & 0x03) << 6) | c4);
      }
      return out;
  },
    //   全屏
  quanp(){
    var element = document.documentElement;
    if (element.requestFullscreen) {
        element.requestFullscreen();
    } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    }
  },
  //退出全屏
  tquanp(){
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
  },
    //转换时间
  format(shijianchuo) {            
    function add0(res){ return res < 10 ? '0' + res : res };
      //shijianchuo是整数，否则要parseInt转换
      shijianchuo=parseInt(shijianchuo);
      if(shijianchuo/1000000000000<1){
          shijianchuo=shijianchuo*1000;
      }
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
  },
  //近几天的日期
  getJjtDate(t){
    if(!t){
        t=15;
    }
    function addDate(dd,dadd){
        var a = new Date(dd)
        a = a.valueOf()
        a = a + dadd * 24 * 60 * 60 * 1000
        a = new Date(a)
        return a;
    }
    function add0(res){ return res < 10 ? '0' + res : res };
    var now = new Date();
    var dataTitle = [];//保存获取到的日期
    for(var i=0;i<t;i++){
        var y = now.getFullYear();
        var month = (now.getMonth()+1)
        dataTitle[i]=(y+''+add0(month)+""+add0((now.getDate()-1)));
        now = addDate(month+"/"+now.getDate()+"/"+now.getFullYear(),-1);
    }
    return dataTitle
  }
}



// WEBPACK FOOTER //
// ./src/api/api_user.js